var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arroba 1",
    clipPath: "url(#clip0_2364_3515)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.278 18.3281C20.2055 18.3281 18.5195 20.0148 18.5195 22.0882C18.5195 24.1616 20.2055 25.8483 22.278 25.8483C24.3505 25.8483 26.0365 24.1616 26.0365 22.0882C26.0365 20.0148 24.3505 18.3281 22.278 18.3281Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.1105 0.78125C10.3665 0.78125 0.8125 10.3394 0.8125 22.0884C0.8125 33.8374 10.3665 43.5626 22.1105 43.5626C33.8544 43.5626 43.5755 33.8374 43.5755 22.0884C43.5755 10.3394 33.8544 0.78125 22.1105 0.78125ZM31.0473 28.3552C29.354 28.3552 27.8608 27.5062 26.9533 26.2164C25.8046 27.5172 24.1446 28.3552 22.2775 28.3552C18.8237 28.3552 16.0134 25.5437 16.0134 22.0884C16.0134 18.633 18.8237 15.8216 22.2775 15.8216C23.693 15.8216 24.9858 16.3116 26.036 17.1069V17.0749C26.036 16.3822 26.5963 15.8216 27.2888 15.8216C27.9813 15.8216 28.5416 16.3822 28.5416 17.0749C28.5416 19.8624 28.5416 20.553 28.5416 23.3417C28.5416 24.7236 29.666 25.8485 31.0473 25.8485C32.4286 25.8485 33.5529 24.7236 33.5529 23.3417C33.5529 14.9533 28.0044 10.8081 22.2775 10.8081C16.0599 10.8081 11.0021 15.8681 11.0021 22.0884C11.0021 28.3086 16.0599 33.3686 22.2775 33.3686C24.7832 33.3686 27.153 32.5657 29.1314 31.0455C30.4529 30.0363 31.9661 32.0285 30.6582 33.0332C28.237 34.8925 25.3398 35.8753 22.2775 35.8753C14.6787 35.8753 8.49648 29.6905 8.49648 22.0884C8.49648 14.4862 14.6787 8.30141 22.2775 8.30141C29.2012 8.30141 36.0586 13.4097 36.0586 23.3417C36.0586 26.1067 33.8111 28.3552 31.0473 28.3552Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2364_3515"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.763,
    height: 42.7814,
    fill: "white",
    transform: "translate(0.8125 0.78125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.2d38776497ee701fe482f0d75679fbf3.svg";
export { ForwardRef as ReactComponent };